"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextReaderApp = void 0;
var TextReaderApp_1 = require("./TextReaderApp");
Object.defineProperty(exports, "TextReaderApp", { enumerable: true, get: function () { return TextReaderApp_1.TextReaderApp; } });
//# sourceMappingURL=index.js.map